<!-- eslint-disable no-undef -->
<script setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import PrimaryDomainNav from '@/components/navigation/PrimaryDomainNav.vue';
  import DomainSubnav from '@/components/navigation/DomainSubnav.vue';
  import { primaryNav, getSubnavForPath } from '@/config/domainNavigation';
  import { useFeatureFlags } from '@/composables/useFeatureFlags';

  defineOptions({
    name: 'DomainShell'
  });

  const route = useRoute();
  const { isDomainEnabled } = useFeatureFlags();

  const primaryItems = computed(() => primaryNav.filter((item) => isDomainEnabled(item.id)));
  const subnav = computed(() => getSubnavForPath(route.path));
</script>

<template>
  <div class="flex min-h-0 min-w-0 flex-1">
    <PrimaryDomainNav :items="primaryItems" />
    <div class="flex min-h-0 min-w-0 flex-1 flex-col">
      <DomainSubnav :items="subnav" />
      <div class="flex min-h-0 min-w-0 flex-1 flex-col">
        <slot />
      </div>
    </div>
  </div>
</template>
